<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Reisaftrek openbaar vervoer
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Voorwaarden reisaftrek openbaar vervoer</b><br/>
                Betaalt de werknemer zelf de reiskosten? Dan heeft hij recht op reisaftrek openbaar vervoer als hij
                voldoet aan beide volgende voorwaarden:
                <li>de afstand van een enkele reis van de woning naar het werk met het openbaar vervoer is meer dan 10
                    kilometer.
                </li>
                <li>De werknemer reist per week meestal 1 dag of meer naar uw werk. Of hij reist op minimaal 40 dagen in
                    een kalenderjaar naar dezelfde werkplek. Hij mag alleen reizen meetellen die bij binnen 24 uur heen
                    en terug maakt.
                </li>
                <div class="space10>"></div>

                Voldoet de werknemer aan beide bovenstaande voorwaarden? Dan heeft hij 1 van de volgende verklaringen
                nodig:
                <li>een openbaarvervoerverklaring. <br/>Met een openbaarvervoerverklaring bewijst de werknemer dat
                    hij met het openbaar vervoer reist. Vraag de openbaarvervoerverklaring aan bij het vervoerbedrijf.
                    Enkele vervoersmaatschappijen geven deze gegevens al aan de Belastingdienst door. Informeer bij uw
                    vervoersbedrijf of zij deze gegevens aan de Belastingdienst doorgeven. Geven zij de gegevens niet
                    door? Vraag dan de openbaarvervoerverklaring zelf aan bij het vervoerbedrijf. De NS geeft
                    automatisch aan de Belastingdienst de gegevens door van NS-reizigers met een abonnement, die in
                    aanmerking komen voor een openbaarvervoerverklaring.
                </li>
                <li>een reisverklaring. <br/>
                    Krijgt de werknemer geen openbaarvervoerverklaring omdat hij met losse vervoersbewijzen of met de
                    OV-chipkaart reist? Vraag dan bij de werkgever een reisverklaring aan. De belastingdienst kan de
                    werknemer later vragen om de vervoersbewijzen (losse vervoersbewijzen of het overzicht van de
                    transacties met uw OV-chipkaart) en de betalingsbewijzen daarvan. Als hij de reisverklaring en de
                    vervoers- en betalingsbewijzen dan niet heeft, krijgt hij geen reisaftrek. Transactieoverzichten van
                    een anonieme OV-chipkaart accepteert de Belastingdienst niet.
                </li>
                <div class="space10>"></div>

                Let op! Werknemers kunnen het online transactieoverzicht van de reizen met OV-chipkaart activeren en het
                overzicht op tijd bewaren. Vanaf het moment dat de werknemer het transactieoverzicht heeft aangevraagd,
                kan hij steeds maximaal 18 maanden terugkijken.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Verschillende werkplekken
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als de werknemer buiten Nederland woont, kan hij alleen reisaftrek openbaar vervoer krijgen voor de
                inkomsten uit loondienst in Nederland.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse11">
                Werknemer woont in het buitenland
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als de werknemer buiten Nederland woont, kan hij alleen reisaftrek openbaar vervoer krijgen voor de
                inkomsten uit loondienst in Nederland.
            </div>
        </div>
    </div>

</div>

